import { render } from "@react-email/components";
import { useEffect, useState } from "react";
import { LoadAvailabilityEmail } from "./LoadAvailabilityEmail";
import { formatLocation, formatCurrency } from "@/utils/text";
import { formatShortDate } from "@/utils/date";
import { useUserAccount } from "@/hooks/useUserAccount";

export const useEmailContent = ({ emailAddress, load, user }) => {
  const [mailtoLink, setMailtoLink] = useState(null);

  const loadId = load.externalLoadId;
  const subject = `Load #${loadId} – Availability check`;

  const firstStop = load.itineraryStops?.[0];
  const lastStop = load.itineraryStops?.[load.itineraryStops.length - 1];

  const origin = firstStop ? formatLocation(firstStop.stopCity, firstStop.stopState) : "";
  const destination = lastStop ? formatLocation(lastStop.stopCity, lastStop.stopState) : "";
  const pickupDate = formatShortDate(load.pickupDate);
  const deliveryDate = formatShortDate(load.deliveryDate);
  const rate = formatCurrency(load.offerRate);

  const { data: account } = useUserAccount();
  const userName = account?.displayName || user?.displayName || "[Your Name]";
  const companyName = account?.company?.name || "[Company Name]";
  const mcNumber = account?.company?.mcNumber || "[MC Number]";

  useEffect(() => {
    const generateEmail = async () => {
      const emailComponent = LoadAvailabilityEmail({
        loadId,
        origin,
        destination,
        pickupDate,
        deliveryDate,
        rate,
        userName,
        companyName,
        mcNumber,
      });

      const plainTextContent = await render(emailComponent, { plainText: true });
      setMailtoLink(`mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(plainTextContent)}`);
    };

    generateEmail();
  }, [loadId, origin, destination, pickupDate, deliveryDate, rate, userName, companyName, mcNumber, emailAddress, subject]);

  return mailtoLink;
};
